import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async getQuotas(store) {
    const { commit, state, rootState } = store;
    const { page, per_page } = rootState.misc.pagination;
    return await axios({
      url: `/v1/packages/${state.pkg.id}/quotas/list?page=${page}&per_page=${per_page}`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setQuotas', resp.data.data);
        commit('misc/setTotalPages', resp.data.meta.pagination.total_pages, { root: true });
        return Promise.resolve(resp.data.meta.pagination);
      })
      .catch(parseApiError);
  },
  async createQuota(store, quota) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/quotas`,
      method: 'POST',
      data: { ...quota },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getQuotas');
        return Promise.resolve(quota);
      })
      .catch(parseApiError);
  },
  async updateQuota(store, quota) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/quotas/${quota.id}`,
      method: 'PUT',
      data: { ...quota },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getQuotas');
        return Promise.resolve(quota);
      })
      .catch(parseApiError);
  },
  async deleteQuota(store, quotaID) {
    const { dispatch, state } = store;
    return await axios({
      url: `/v1/quotas/${quotaID}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getQuotas');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async blockQuota(store, quota) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/quotas/${quota.id}/block`,
      method: 'POST',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getQuotas');
        return Promise.resolve(quota);
      })
      .catch(parseApiError);
  },
  async unblockQuota(store, quota) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/quotas/${quota.id}/unblock`,
      method: 'POST',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getQuotas');
        return Promise.resolve(quota);
      })
      .catch(parseApiError);
  },
};

export default actions;